<div class="page">
  <app-page-header page-title="properties.documents.summaryDocs.pageTitle">
  </app-page-header>
  <div class="page-content">
    <mat-card class="custom-card card-no-border-bottom">
      <div class="row">
        <div class="col-12">
          <mat-card-title>{{ 'properties.documents.summaryDocs.parameters' | translate }}
          </mat-card-title>
          <!-- <mat-card-subtitle></mat-card-subtitle> -->
        </div>
      </div>
      <mat-card-content class="m-0">
        <mat-expansion-panel [expanded]="showParameters" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="row mt-2">
            <div class="col-8">
              <div class="row">
                <!-- Row 1: Immobili + Società -->
                <div class="col-12 col-md-6 mb-3">
                  <p class="mb-0 custom-label"><strong>{{ 'properties.documents.summaryDocs.properties' | translate }}</strong>
                  </p>
                  <ng-select [items]="propertyOptions$ | async" bindLabel="name" bindValue="_id"
                    [typeahead]="propertyInput$" [loading]="propertiesLoading" [(ngModel)]="selectedProperty"
                    [clearable]="true" [placeholder]="'common.words.search' | translate"
                    [notFoundText]="'common.words.notFound' | translate"
                    [loadingText]="'common.words.loading' | translate">
                  </ng-select>
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <p class="mb-0 custom-label"><strong>{{ 'properties.documents.summaryDocs.filterCompany' | translate }}</strong>
                  </p>
                  <ng-select [items]="companyOptions$ | async" bindLabel="name" bindValue="_id"
                    [typeahead]="companyInput$" [loading]="companiesLoading" [(ngModel)]="selectedCompanyId"
                    (change)="onCompanyChange($event)" [clearable]="true"
                    [placeholder]="'common.words.search' | translate"
                    [notFoundText]="'common.words.notFound' | translate"
                    [loadingText]="'common.words.loading' | translate">
                  </ng-select>
                </div>
                <!-- Row 2: Operatori Archedi + Dipendenti della società -->
                <div class="col-12 col-md-6 mb-3">
                  <p class="mb-0 custom-label"><strong>{{ 'properties.documents.summaryDocs.users' | translate }}</strong>
                  </p>
                  <mat-select [(ngModel)]="selectedUser">
                    <mat-option value="-1">{{ 'common.words.all' | translate }}</mat-option>
                    <mat-option value="none">{{ 'properties.documents.summaryDocs.filterUsersNone' | translate }}</mat-option>
                    <mat-option *ngFor="let adminUser of adminUsers" [value]="adminUser._id">
                      {{ adminUser.firstName }} {{ adminUser.lastName }} - {{ adminUser.email }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <p class="mb-0 custom-label"><strong>{{ 'properties.documents.summaryDocs.filterEmployee' | translate }}</strong>
                  </p>
                  <mat-select [(ngModel)]="selectedSubUser"
                    [disabled]="!selectedCompanyId || selectedCompanyId === '-1' || employeesLoading">
                    <mat-option value="-1">{{ 'common.words.all' | translate }}</mat-option>
                    <mat-option value="none">{{ 'properties.documents.summaryDocs.filterEmployeeNone' | translate }}</mat-option>
                    <mat-option *ngFor="let employee of companyEmployees" [value]="employee.userId">
                      {{ employee.firstName }} {{ employee.lastName }} - {{ employee.email }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="col-12 col-md-6 mb-3">
                  <div class="row">
                    <div class="col-12">
                      <form [formGroup]="form">
                        <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options">
                        </formly-form>
                      </form>
                    </div>
                    <div class="col-12">
                      <button class="navigation-button w-50" mat-flat-button (click)="applyFilter()" color="primary"
                        [disabled]="documentArchiveIsLoading">
                        <mat-icon fontSet="fal" fontIcon="fa-search"></mat-icon>
                        {{ 'properties.documents.summaryDocs.btnSearch' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              
            </div>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <mat-card class="custom-card card-no-border-top">
      <div class="row">
        <div class="col-12 d-flex">
          <mat-card-title>{{ 'properties.documents.summaryDocs.results' | translate }}
          </mat-card-title>
          <button class="navigation-button ml-4" mat-flat-button (click)="onExportToExcel()" color="primary"
            [disabled]="!canExport">
            <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
            {{ 'common.export' | translate }}
          </button>
        </div>
      </div>
      <mat-card-content [ngClass]="{ 'search-area-loading': documentArchiveIsLoading }">
        <div class="row">
          <div class="col-12">
            <ng-container>
              <app-card-spinner [visible]="documentArchiveIsLoading" type="zero"></app-card-spinner>
              <table class="table table-borderless table-striped" matSort (matSortChange)="sortData($event)" matSortDisableClear>
                <thead>
                  <th>#</th>
                  <th class="clickable" mat-sort-header="firstName">
                    {{ 'properties.documents.summaryDocs.firstName' | translate }}</th>
                  <th class="clickable" mat-sort-header="lastName">
                    {{ 'properties.documents.summaryDocs.lastName' | translate }}</th>
                  <th class="clickable" mat-sort-header="insertDate">
                    {{ 'properties.documents.summaryDocs.insertDate' | translate }}</th>
                  <th class="clickable" mat-sort-header="company">
                      {{ 'properties.documents.summaryDocs.company' | translate }}</th>
                  <th class="clickable" mat-sort-header="property">
                    {{ 'properties.documents.summaryDocs.property' | translate }}</th>
                  <th class="clickable" mat-sort-header="insertTotalDoc">
                    {{ 'properties.documents.summaryDocs.insertTotalDoc' | translate }}</th>
                  <th class="clickable" mat-sort-header="insertTotalPdf">
                  {{ 'properties.documents.summaryDocs.insertTotalPdf' | translate }}</th>
                  <th class="clickable" mat-sort-header="deletedTotalDoc">
                    {{ 'properties.documents.summaryDocs.deletedTotalDoc' | translate }}</th>
                  <th class="clickable" mat-sort-header="type">
                    {{ 'properties.documents.summaryDocs.type' | translate }}</th>
                </thead>
                <tbody>
                  <tr *ngFor="let item of sortedData; let i = index">
                    <th style="width: 3%">{{ i + 1 }}</th>
                    <td style="width: 10%">{{ item.firstName }}</td>
                    <td style="width: 20%">{{ item.lastName }}</td>
                    <td style="width: 20%">{{ item.insertDate | date }}</td>
                    <td style="width: 10%">{{ item.company }}</td>
                    <td style="width: 10%">{{ item.property }}</td>
                    <td style="width: 8%">{{ item.insertTotalDoc }}</td>
                    <td style="width: 8%">{{ item.insertTotalPdf }}</td>
                    <td style="width: 8%">{{ item.deletedTotalDoc }}</td>
                    <td style="width: 4%">{{ item.type }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="alert alert-warning my-3" role="alert"
                *ngIf="!sortedData || (sortedData && !sortedData.length)">
                {{ 'common.words.no_search_results' | translate }}
              </div>
            </ng-container>
          </div> <!-- /.col -->
        </div> <!-- /.row -->
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->